<template>
	<!--首页-->
	<div class="app">
		<!--头部-->
		<navHeader></navHeader>
		<!--标题-->
		<div class="header_b">
			<img class="img-fluid" style="width: 100%;" src="../../../static/images/join.jpg" />
			<!--小导航-->
			<div class="nav_x">
				<span><img  src="../../../static/images/add.png"/></span>
				<span><a href="/">首页 </a></span>
				<span>/ 招商加盟</span>
			</div>
		</div>
		<!--项目介绍-->
		<div class="project">
			<div class="comtit">
				<span>项目介绍</span>
				<span>PROJECT INTRODUCTIONR</span>
			</div>
			<div class="container">
				<div class="right">
					<img class="img-fluid" src="../../../static/images/join_pro.png" />
				</div>
				<div class=" left">
					<span>金利高陶瓷</span> “金利高陶瓷”品牌是新明珠陶瓷集团于2008年创建成立， 位于素有南国陶都之称的广东省佛山市南庄镇。经过多年的不懈努力， 佛山市金利高陶瓷有限公司已发展成为产品研发、生产、营销、服务于一体的现代化企业。 作为年轻时尚中高端品牌，金利高陶瓷是一家集产品研发、生产、销售、服务于一体的现代化建陶品牌。 十年来，品牌先后荣获“广东省著名商标”、“陶瓷优质产品认证”、“建材环保产品认证”、“金利高墙地砖质量太平洋保险承保证书”、 “国家强制性3C产品认证”、“中国环境标志认证”、“中国十大品牌”、“佛山十大品牌”、“中国工程建设推荐品牌”、 “资信等级AAA级单位”等一系列荣誉。 金利高陶瓷始终秉承“设计成就梦想”的家装理念，在产品研发上，全面引进意大利萨克米压机、 多通道喷墨打印机、西斯特姆辊筒喷墨印花机,与世界一流的陶丽西、埃思玛格拉斯原材料商合作，以专业化、规模化的生产要求确保产品品质， 满足大规模供货需求。产品涵盖大板、现代仿古砖、通体大理石瓷砖、喷墨抛光砖、超平釉、瓷片和木纹砖等品类，生产规格覆盖300x300、300x600、 600x600、800x800、900x900、750x1500、950x1500、800x1600mm，花色品种达500种，为消费群体提供无限的设计可能。 匠心质造， 臻于至善，“我们只做最好的”。金利高陶瓷建立了严格的企业内控标准，并先后通过了ISO9001质量管理体系认证、ISO14001环境管理体系认证， 产品经过国家权威机构检测，放射性指标符合GB6566-2010的国家标准，属A类产品，其产销和使用范围不受限制。产品被广泛应用于各大著名建筑工程， 如厦门文化中心、广西桂林机场、南开大学、北京长安街东方广场、上海大厦等。 历经10年发展，金利高品牌营销网点遍布世界各地，产品远销欧洲、 东南亚、中东等100多个国家及地区。金利高，为成功而来，展望未来，金利高陶瓷将对产品、展示、渠道、传播、服务等板块进行优势资源整合， 全面增强品牌的综合实力，推进品牌全面升级，实现金利高“有建筑的地方就有金利高陶瓷”的远大愿景。
				</div>

			</div>
		</div>
		<!--加盟优势-->
		<div class="join">
			<div class="comtit">
				<span>加盟优势</span>
				<span>EIGHT ADVANTAGES</span>
			</div>
			<div class="container">
				<div class="row">
					<div class="col-md-6 join_box" v-for="(item,index) in join">
						<div class="join_cot">
							<div class="img"><img class="img-fluid" :src="item.img" /></div>
							<div class="name">{{item.name}}</div>
						</div>
						<div class="join_li">
							<div class="txt">{{item.txt}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--条件-->
		<div class="qua">
			<div class="comtit">
				<span>条件</span>
				<span>QUALFICATION</span>
			</div>
			<div class="container">
				<div class="row">
					<div class="col-7 qua_l">
						<div class="box"></div>
						<div class="img"><img class="img-fluid" src="../../../static/images/qua.png" /></div>
						<div class="row">
							<div class="col-12 box_txt">
								<div class="p"></div>
								<div class="p">
									<span>1.具有独立的运营店铺</span>
									<span>2.认同金利高品牌运营模式，具有品牌运营意识及团队运营能力 </span>
									<span>3.专卖店必须单独专一展示、经营金利高陶瓷品牌的各系列产品</span>
								</div>

							</div>
						</div>

					</div>
					<div class="col-5  qua_r">
						<div><span class="yuan1"><small>独立店铺</small></span></div>
						<div>
							<span class="yuan2"><small>专一展示</small></span>
							<span class="yuan3"><small>品牌运营</small></span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--终端展示-->
		<div class="ter">
			<div class="comtit">
				<span>终端展示</span>
				<span>TERMINAL DISPLAY</span>
			</div>
			<div class="ter_bg">
				<div class="container">
					<div class="row">
						<div class="col">
							<swiperTer :ban="ban"></swiperTer>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--流程-->
		<div class="tec">
			<div class="comtit">
				<span>流程</span>
				<span>TECHNOLOGICAL PROCESS</span>
			</div>
			<div class="container" style="padding-bottom: 30px;">
				<div class="row">
					<div class="col-3 tec_list1" v-for="(item,index) in tecTxt1">
						<div class="tec_li">{{item.txt}}</div>
					</div>
				</div>
				<div class="row">
					<div class="col-12 img">
						<img class="img-fluid" src="../../../static/images/tec_li.png" />
					</div>
				</div>
				<div class="row">
					<div class="col-3 tec_list2" v-for="(item,index) in tecTxt2">
						<div class="tec_li">{{item.txt}}</div>
					</div>
				</div>
			</div>
			<!--表单-->
			<inputBtn></inputBtn>
		</div>
		<!--底部-->
		<comFooter></comFooter>
	</div>
</template>
<script>
	import navHeader from '@/components/navHeader/index.vue'
	import comFooter from '@/components/comFooter/index.vue'
	import swiperTer from '@/components/swiperTer/index.vue'
	import inputBtn from '@/components/inputBtn/index.vue'
	export default {
		components: {
			navHeader,
			comFooter,
			swiperTer,
			inputBtn
		},
		data() {
			return {
				ban:[ 
				  {img:"http://www.goldceramics.cn/kps01/M00/3A/6D/wKiAiVlVuu3KfoO5AAbvhmEzbvA388.jpg",tit:"金利高陶瓷专卖店外立面"},
				  {img:"http://www.goldceramics.cn/kps01/M00/3A/6D/wKiAiVlVuw6ebtHuAAVZ7kE_ViI660.jpg",tit:"金利高陶瓷店中店外立面"},
				  {img:"http://www.goldceramics.cn/kps01/M00/3A/6D/wKiAiVlVuyeUSxWfAAX8C6qhICo087.jpg",tit:"金利高陶瓷专卖店形象大堂"},
				  {img:"http://www.goldceramics.cn/kps01/M00/3A/6D/wKiAiVlVuzrzj2T1AAYqfw8DKmI627.jpg",tit:"金利高陶瓷专卖店选材区形象"},
				  {img:"http://www.goldceramics.cn/kps01/M00/3A/6D/wKiAiVlVuyeUSxWfAAX8C6qhICo087.jpg",tit:"金利高陶瓷专卖店形象大堂"},
				  {img:"http://www.goldceramics.cn/kps01/M00/3A/6D/wKiAiVlVuu3KfoO5AAbvhmEzbvA388.jpg",tit:"金利高陶瓷专卖店外立面"},
				],
				tecTxt1: [{
					txt: '1.加盟洽谈'
				}, {
					txt: '2.签订合同'
				}, {
					txt: '3.店面装修'
				}, {
					txt: '4.系统培训'
				}, ],
				tecTxt2: [{
					txt: '5.政策咨询'
				}, {
					txt: '6.店面设计'
				}, {
					txt: '7.店面验收'
				}, {
					txt: '8.开业庆典'
				}, ],
				join: [{
						name: "品牌",
						txt: "历史悠久、加盟风险低。金利高经过十来年的发展，是集现代化生产、集约化运营于一体的优势企业。",
						img: "../../../static/images/join1.png"
					},
					{
						name: "荣誉",
						txt: "先后荣获“建材环保产品认证”、“国家强制性3C产品认证”、“陶瓷优质产品认证”、“陶瓷行业十大品牌”、“资信等级AAA级单位”等众多荣誉称号。",
						img: "../../../static/images/join2.png"
					},
					{
						name: "产品",
						txt: "抛光砖、瓷片、大理石瓷砖、至尊石、全抛釉、大板等品类、500多个花色品种，健全的产品体系，强大的配套能力，紧跟潮流的产品花色设计，帮你迅速打开市场，实现出色的经营业绩。",
						img: "../../../static/images/join3.png"
					},
					{
						name: "营销",
						txt: "配备优秀的专业陶瓷营销、市场、推广团队，根据区域状况深入调研，为您量身定做区域宣传指导计划，制定促销方案与实施指导，帮您快速提高区域品牌知名度，实现市场领跑，财富增值。",
						img: "../../../static/images/join4.png"
					},
					{
						name: "管理",
						txt: "覆盖全国的健全营销网络和营销管理系统，专业的营销团队，提供科学系统的管理模式，并提供多样化的成功模板，让你的加盟无后顾之忧。",
						img: "../../../static/images/join5.png"
					},
					{
						name: "培训",
						txt: "全国经销商大会，导购培训……全方位覆盖，线上线下多种平台，行业著名培训专家、公司培训师联袂打造，公司化管理、渠道建设、导购素质提升等多方面的专业培训课程，让你的团队短时间内实力倍增。",
						img: "../../../static/images/join6.png"
					},
					{
						name: "装修",
						txt: "由公司专职设计师严格按照统一VI标准设计图纸，专职监理师现场指导施工，并推荐专业的装修施工团队，确保按时按质完成装修进度，让你的店面早日成为赢利平台。",
						img: "../../../static/images/join7.png"
					},
					{
						name: "区域",
						txt: "享有签订区域的品牌使用权和品牌商品经营权。在加盟合同期满后，加盟店愿意继续合作，按总部政策办理新的加盟合同。",
						img: "../../../static/images/join8.png"
					}

				]

			}
		},
		created() {

		},
		mounted() {
         
		},
		methods: {
		},
	}
</script>
<style scoped lang="less">
	@w: 19.2vw;
	/*项目介绍*/
	
	.project {
		.left {
			font-size: 18/@w;
			color: #8A8A8A;
			font-weight: bold;
			border-radius: 0px 0px 40/@w 40/@w;
			border: 4/@w solid rgba(163, 128, 97, 1);
			padding: 0 20/@w 30/@w 20/@w;
			box-sizing: border-box;
			span {
				display: block;
				text-align: center;
				color: #A38061;
				padding: 20/@w;
				box-sizing: border-box;
			}
		}
	}
	/*加盟优势*/
	
	.join {
		.join_box {
			position: relative;
			font-size: 18/@w;
			.join_cot {
				position: relative;
				left: 0;
				top: 30/@w;
				div {
					display: inline-block;
					color: #855B1A;
					font-weight: bold;
				}
				img {
					width: 100/@w;
					min-width: 50px;
				}
				.name {
					margin-left: 15px;
				}
			}
			.join_li {
				background: rgba(251, 244, 233, 1);
				box-shadow: 0px 6px 13px -3px rgba(0, 0, 0, 0.5);
				border-radius: 10px;
				height: 580/3.2/@w;
				min-height: 100px;
				color: #8A8A8A;
				padding: 40/@w;
				box-sizing: border-box;
			}
		}
	}
	/*条件*/
	
	.qua {
		position: relative;
		margin-bottom: 120px;
		.qua_l {
			padding-top: 12px;
		}
		.box {
			width: 100/@w;
			height: 100/@w;
			min-width: 50px;
			min-height: 50px;
			position: absolute;
			left: 0;
			top: 0;
			background: #A38061;
			z-index: -1;
		}
		.img {}
		.box_txt {
			position: absolute;
			right: -310/@w;
			bottom: 60/@w;
			.p {
				color: #FBF4E9;
				font-size: 16/@w;
				&:nth-child(1) {
					width: 300/@w;
					height: 300/2.14/@w;
					background: #A38061;
					opacity: .6;
					position: absolute;
					left: -20px;
					top: -20px;
					min-width: 100px;
					min-height: 100/2.1px;
				}
				&:nth-child(2) {
					position: absolute;
					left: 0;
					top: 0;
					background: rgba(163, 128, 97, 1);
					padding: 26/@w 80/@w;
					span {
						display: block;
					}
				}
			}
		}
		.qua_r {
			text-align: center;
			line-height: 30px;
			vertical-align: middle;
			span {
				font-size: 18/@w;
				width: 100/@w;
				height: 100/@w;
				border-radius: 50%;
				text-align: center;
				display: inline-block;
				color: #FBF4E9;
				vertical-align: middle;
				line-height: 100/@w;
			}
			.yuan1 {
				background: rgba(237, 146, 6, 1);
				box-shadow: 0px 2px 21px 0px rgba(237, 146, 6, 1);
				margin-top: 30px;
			}
			.yuan2 {
				background: rgba(247, 195, 115, 1);
				box-shadow: 0px 2px 21px 0px rgba(247, 195, 115, 1);
				margin-top: 20/@w;
			}
			.yuan3 {
				background: rgba(168, 95, 17, 1);
				box-shadow: 0px 2px 21px 0px rgba(168, 95, 17, 1);
				margin-top: 20/@w;
				margin-left: 20/@w;
			}
		}
		@media screen and (max-width: 768px) {
			.qua_r {
				span {
					line-height: 50px;
					width: 50px;
					height: 50px;
				}
				.yuan2,
				.yuan3 {
					margin-top: 0;
				}
			}
		}
		@media screen and (max-width: 480px) {
			.qua_r {
				.yuan1 {
					margin-top: 0;
				}
			}
		}
	}
	/*终端展示*/
	
	.ter {
		.ter_bg {
			background: url("../../../static/images/terBg.png") no-repeat center;
			background-size: 100% 100%;
			overflow: hidden;
		}
	}
	
	.tec {
		.tec_list1,
		.tec_list2 {
			font-size: 18/@w;
			color: #FFFFFF;
			&:nth-child(1),
			&:nth-child(3) {
				.tec_li {
					background: url("../../../static/images/tec1.png") no-repeat center;
					background-size: 100% 100%;
					overflow: hidden;
					padding: 15/@w 0 30/@w 0;
				}
			}
			&:nth-child(2),
			&:nth-child(4) {
				.tec_li {
					background: url("../../../static/images/tec2.png") no-repeat center;
					background-size: 100% 100%;
					overflow: hidden;
					padding: 15/@w 0 30/@w 0;
				}
			}
			.tec_li {
				text-align: center;
			}
		}
		.tec_list2 {
			&:nth-child(1),
			&:nth-child(3) {
				.tec_li {
					background: url("../../../static/images/tec3.png") no-repeat center;
					background-size: 100% 100%;
					overflow: hidden;
					padding: 30/@w 0 15/@w 0;
				}
			}
			&:nth-child(2),
			&:nth-child(4) {
				.tec_li {
					background: url("../../../static/images/tec4.png") no-repeat center;
					background-size: 100% 100%;
					overflow: hidden;
					padding: 30/@w 0 15/@w 0;
				}
			}
		}
		.img {
			text-align: center;
			margin: 20/@w 0;
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/join/index.vue